import { render, staticRenderFns } from "./Presentism.vue?vue&type=template&id=4753f6a2"
import script from "./Presentism.vue?vue&type=script&lang=js"
export * from "./Presentism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports